import { useEffect, useRef, useState } from "react";
import { Select, message } from "antd";
import "../../../index.css";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../common/customLoader";
import {
  fetchRoleAsDropdownThunk,
  updateRoleThunk,
} from "../../store/thunks/usersThunk";
import { useDispatch } from "react-redux";

const SwitchRole = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const slsRole = secureLocalStorage.getItem("role");
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const formRef = useRef(null);

  /*begin::getRoles will fetch the list of Roles*/
  const getRoles = async () => {
    const payload = {};

    await dispatch(fetchRoleAsDropdownThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((role, index) => {
          temp.push({ label: role?.name, value: role?.name?.toLowerCase() });
        });
        setRoles(temp);
      })
      .catch((error) => {});
  };
  /*end::getRoles will fetch the list of Roles*/

  const handleSubmit = async (event) => {
    event.preventDefault();
    setShowLoader(true);

    const headers = {
      role: slsRole,
    };
    const payload = {
      lIUId: slsLIUId,
      selectedRole,
    };

    await dispatch(updateRoleThunk(payload))
      .unwrap()
      .then((response) => {
        setShowLoader(false);

        resetForm();
        if (response) {
          const parseJson = JSON.parse(response);
          secureLocalStorage.setItem("role", parseJson?.role);
          message.success(parseJson?.message);
          secureLocalStorage.setItem("switchRole", true);

          navigate("/dashboard");
        }
      })
      .catch((error) => {
        message.error("There was an error!" + error);
        setShowLoader(false);
        // if (error.data && error.data.message) {
        //   setErrors(error.data.message);
        // } else {
        //   message.error("An error occurred while saving the settings");
        // }
      });
  };

  const resetForm = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
    setSelectedRole(undefined);
  };

  useEffect(() => {
    getRoles();
  }, []);
  return (
    <div className="all-content switchRoleContainer">
      <div className="all-table-holder">
        <CustomLoader showLoader={showLoader} />
        <form onSubmit={handleSubmit} ref={formRef}>
          <div className="">
            <Select
              showSearch
              allowClear
              options={roles}
              value={selectedRole} // Controlled value
              placeholder="Select an option"
              className="w-100"
              onChange={(val) => {
                setSelectedRole(val);
              }}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  ?.toLowerCase()
                  .includes(input?.toLowerCase())
              }
            ></Select>
          </div>
          <div className="buttonsContainer">
            <button
              className="ant-btn ant-btn-primary submit-btn border-0 me-4 rounded"
              type="submit"
              role="button"
              aria-expanded="false"
              aria-controls="collapseContent"
            >
              Update
            </button>
            <button
              type="button"
              className="ant-btn ant-btn-primary submit-btn border-0 me-4 rounded"
              onClick={resetForm}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SwitchRole;
